import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import React, {
  useCallback,
  useRef,
  useState,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import {
  Button,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../../utilities/AgGridTable";
import Progress from "./Progress";
import { Box } from "@mui/system";
import { blue } from "@mui/material/colors";
import dataSpacePlaning from "./dataSpacePlaning";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from "react-select";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import RequestChange from "./RequestChange";
import jwtDecode from "jwt-decode";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#fff !important",
  backgroundColor: blue[500],
  padding: "12px 30px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "inline-block",

  "&:hover": {
    backgroundColor: blue[700],
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  fontSize: 11,
  color: "#fff !important",
  background: `${theme.palette.primary.main}`,
  borderRadius: 20,
  padding: "5px 10px",
  cursor: "pointer",
}));

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;
const factoryVendorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;

const PDFSvg = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={42} height={42} fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_22_1661" transform="scale(0.015625)" />
      </pattern>
      <image
        id="image0_22_1661"
        width={64}
        height={64}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACIklEQVR4nO2asU4CQRCGt6Kw11hoaXwJ7NV3slWfxRhL7VFbCy2wVihN1NLmMwtLAgTuZnFnmcX9ys1k55/vDjg251ylUqmsALAFnAGvwA/rYQhcAh2XE2AHeMIOF7mHfwmN/dUfkS3AbJZuaD/M1XAbeA5N+8DuOgWETHn6s2D4rAGW59Lvz5LhswVozqbbn4bhswRoz6fXn5bh1QMIUOuPYHjVAEJU+iMcXi1ABMn7M37Cmzzk+N/7nawBDAg4m3rIaRv+KNQO3AYJ6BPPebIABgT8RAw+8MNn/zOiLCDthsqM01YB2DWqTL0DAtmNAqfAO+Xgs56kFPBOebylFDDCFYI4L8JC8YZGqAICyUwh3fC/CwAeEZznL6j7Bm6AQ8F+ngerAkTn+Q01H8CeoK5nWoBrOc+fr/NDA7dh+Sp6EMsClgy8SNR+WP5qqttYATF1RQlgwUnSxgtoO0maLLT1WeUXwKKAwfxJ0h8F9Ir7DpDUTX0JfjbVSShOAOPh78LydfQgpQpY8iB0ED3IijmctDCi7l74GfV103z5Kz89fMx+q+Z1qQVYoQoIJDOFdEMjVAGBZKaoh6Kc+FNWysFnPU73WTFC8rxUAYmNKhPi1jvAmTWqTL0DAmpGGZ/Dz5y4GFtTFzCiramltT/B3IaWBluXgPv5/9/G1nQFWEdDwDDs2XXGUXlTFbigPNK9qQp0goTJnWCZtb+pWqlUXNH8AuE5t1PdlD8VAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
);

const PPTSvg = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <rect width={42} height={42} fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_22_1662" transform="scale(0.015625)" />
      </pattern>
      <image
        id="image0_22_1662"
        width={64}
        height={64}
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACyklEQVR4nO2bvWsUQRiHNxpREMHKXksDYqGlIFhaaKEiFoqVVhqxs7EQwUa0ExvRgBYROxEhoEVIpcZYiX+ACAZNLn5Ec5pHJv6E8XJ7s3s7c7Or88CS3X1n5n33ye7eJTubZYlEogzAEWAGaDM4XgBbstgAR4nHK2BzbAEzKuYMMNwlvoLnnDZPgPU+xy+FddoP58RDCnivnw+AtT5zFMZ1gIEF7ADmtH4HGPKZp/YCtL4XWNSuyz7zNEKAtg9Yl+J5n7kaIUD7TgDLWk76zNcIAdp/QaElYL/PnI0QoNhVhb8Ce3zmbYqAIeCWmswDO33mrr0AxdcBD9XsLbDVZ/7aCCjBa5/56yBgsqwBn/mjCyhDEiCiGSZ0AQ6SABHNMKELcJAEiGiGCV2AgyRARDNM6AIcJAEimmFCF+AgCRDRDBO6AAdJgIhmmNAFOEgCRDTDhC7Agff8wBTNZ7Ky0YazXFlA1lBU/s9oAoDTwLiWe8A1YLcVP5UX1+Ov8S6LaberRP0/Ygr4AHxU4feBlh5srhwAMKtH3qvimoQxoQWNY9Yfm6fEJepvxxQwBzy3tvdpyCuWoJd58Y46nvZZ/1KdBBzTkJdyBPwV9yTge2wBLZ26z3R6m+1tloCFvLgnAd9iC5gFbuoGN2pPd5OA3LgnAYu1uQQ6kYDpVQG/Ar6U7de3AM3huf5nAlNNBHwu26+KgIvAO2CD9VX6do/25tofKzDuG+BG0TqsfoZPZftVugTsOXzAGkfbnnGrXdd5iQX6GRb66evlHhAbld+qOkDTmf/f/xx+VEXAJuBu54g92veMh6bLwY8BG30MfNx8nDRIgJk2d9b34CMNErA9aIKsz3hogucnCfhNtN+Ag+D5SQIY+CszRdGU2Wr/ASrx0tTooF6aKoKpBTin9NMhEx2k/hwKJsAAHDaWB/zipIu2agp78IlE9s/xCyrsqUzC5HpoAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
);

const Download = (props) => {
  const { data } = props;
  const downloadFile = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.downloadFile}`;
  const downloadPath = `${downloadFile}/${data.data?.uploadWinnerFile}?path=${data.data?.uploadWinnerPath}`;

  const loadFiles = async () => {
    const blob = await fetch(downloadPath, OAuthService.config()).then((resp) =>
      resp.blob()
    );
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = data.data?.uploadWinnerFile;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(objUrl);
    document.body.removeChild(a);
  };

  return (
    <span>
      <Button
        variant="outlined"
        size="small"
        onClick={loadFiles}
        startIcon={<FuseSvgIcon>heroicons-outline:download</FuseSvgIcon>}
      >
        Download
      </Button>
    </span>
  );
};

export default function IndividualKitchenDesignReview(props) {
  const { id } = useParams();
  const classes = useStyles(props);
  const [currentStatus, setCurrentStatus] = useState();
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState();
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [btnDisable, setBtnDisable] = useState(false);
  const gridRef = useRef();
  const navigate = useNavigate();

  const Actions = (params) => {
    const { data } = params;
    console.log('DATA: ', data)
    const [open, setOpen] = useState(false);

    const handleClose = () => {
      setOpen(false);
    };

    const handleApprove = () => {
      setBtnDisable(true);
      const payload = {
        ...data,
        status: "Approved",
      };
      params.node.setData(payload);
    };

    const handleReject = () => {
      setBtnDisable(true);
      setOpen(true);
    };

    const handleReqCommentSubmit = async (value) => {
      const payload = {
        ...data,
        comment: value,
        status: "Rejected",
      };
      setOpen(false);
      params.node.setData(payload);
      // try {
      //   await OAuthService.putData(`${url}/${id}`, payload)
      //   .then(resp => {
      //     setOpen(false);
      //     setCurrentStatus(resp?.dsLifeCycle)
      //   })
      //   // setTimeout(() => { navigate("/design-studio/individual-kitchen-design/" + id) }, 400);
      // } catch (error) {
      //   console.log(error);
      //   setError(error.message);
      // }
    };

    return !!params.node.data.status ? (
      <span>{params.node.data.status}</span>
    ) : (
      <>
        <Tooltip title={"Approve"}>
          <IconButton onClick={handleApprove}>
            <FuseSvgIcon size={24} color="primary">
              heroicons-outline:check
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <Tooltip title={"Reject"}>
          <IconButton onClick={handleReject}>
            <FuseSvgIcon size={24} color="primary">
              heroicons-outline:x
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <Tooltip title={"Comment"}>
          <IconButton onClick={handleReject}>
            <FuseSvgIcon size={24} color="primary">
              heroicons-outline:annotation
            </FuseSvgIcon>
          </IconButton>
        </Tooltip>
        <RequestChange
          open={open}
          handleClose={handleClose}
          handleReqCommentSubmit={handleReqCommentSubmit}
          title={"Kitchen Item Changes"}
        />
      </>
    );
  };

  const handleApproveAll = async () => {
    const tempData = {
      ...data,
      isDsLifeCyclePassForNextState:
        data?.dsLifeCycle === "INDIVIDUAL_KITCHEN_DESIGN_REVIEW",
      isDsStatusPassForNextState: false,
    };
    await OAuthService.putData(`${url}/${id}`, tempData);
    navigate("/design-studio/success");
  };
  const handleBack = () => {
    navigate("/design-studio/individual-kitchen-design/" + id);
  };
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [changeHistory, setChangeHistory] = useState([]);
  const [productId, setProductId] = useState([]);

  const SelectProduct = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refVendor = useRef();
    const [error, setError] = useState("");
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);

    const getVendorsList = async () => {
      OAuthService.getList(factoryVendorUrl + `?size=1000`)
        .then((list) => {
          const { factoryVendors } = list.data?._embedded;
          const activeVender = factoryVendors.filter((item) => item.active);
          setVendors(
            activeVender?.map((vendor) => ({
              label: vendor.name,
              value: vendor.id,
            }))
          );
          const vendor = factoryVendors.filter(
            (vendor) => vendor.name === data[colDef.field]
          );
          if (vendor.length > 0)
            setSelectedVendor({ value: vendor[0].id, label: vendor[0].name });
        })
        .catch((err) => setError(err.message));
    };

    const handleVendorChange = (value) => {
      if (!value) return;
      data.productId = value.value;
      props.node.setData(data);
      setSelectedVendor(value);
      // setOpenCom(false);
    };

    useEffect(() => {
      getVendorsList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedVendor?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refVendor}
          value={selectedVendor}
          onChange={handleVendorChange}
          options={vendors}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectRange = forwardRef((props, ref) => {
    const { data, colDef, node } = props;
    console.log(props);
    const refRange = useRef();
    const [range, setRange] = useState([]);
    const [selectedRange, setSelectedRange] = useState(null);
    const [allItems, setAllItems] = useState([]);

    if (!productId) return;
    const getRangeList = async () => {
      if (!data.product) {
        alert("Please select a product first");
        return;
      }
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Range" === d._class
      );

      setAllItems(productList);
      setRange(
        productList.map((range) => ({
          value: range.productId,
          label: range.productName,
        }))
      );
      const range2 = ranges.filter((r) => r.productName === data[colDef.field]);
      if (range2.length > 0)
        setSelectedRange({
          value: range2[0].productId,
          label: range2[0].productName,
        });

      // OAuthService.getList(rangeUrl + `?vendorId=${data.productId}`)
      //   .then((list) => {
      //     const { ranges } = list.data?._embedded;
      //     console.log('ranges', ranges)

      //   })
      //   .catch((err) => setError(err.message));
    };

    const handleRangeChange = (value) => {
      if (!value) return;
      const selectedRange = allItems.filter(
        (item) => item.productName === value.label
      )[0];
      if (colDef.field === "range1")
        data.priceGroup = selectedRange?.priceGroup?.pgId;
      else if (colDef.field === "range2")
        data.priceGroup2 = selectedRange?.priceGroup?.pgId;
      console.log("value: ", data);
      setSelectedRange(value);
    };

    useEffect(() => {
      getRangeList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedRange?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refRange}
          value={selectedRange}
          onChange={handleRangeChange}
          // // isMulti
          options={range}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectCarCass = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refCarCass = useRef();
    const [carCass, setCarCass] = useState([]);
    const [selectedCarCass, setSelectedCarCass] = useState(null);

    const getCarCassList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      console.log("list", list);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Carcass" === d._class
      );
      setCarCass(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const cc = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (cc.length > 0)
        setSelectedFront({
          label: `${cc[0].productId} ${cc[0].productName}`,
          value: `${cc[0].productId} ${cc[0].productName}`,
        });
    };

    const handleCarCassChange = (value) => {
      if (!value) return;
      setSelectedCarCass(value);
    };

    useEffect(() => {
      getCarCassList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCarCass?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refCarCass}
          value={selectedCarCass}
          onChange={handleCarCassChange}
          options={carCass}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectFront = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refFront = useRef();
    const [front, setFront] = useState([]);
    const [selectedFront, setSelectedFront] = useState(null);

    const getFrontList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Range" === d._class
      );

      console.log("productList", productList);

      setFront(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const SELECTED_FRONT = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (SELECTED_FRONT.length > 0)
        setSelectedFront({
          label: `${SELECTED_FRONT[0].productId} ${SELECTED_FRONT[0].productName}`,
          value: `${SELECTED_FRONT[0].productId} ${SELECTED_FRONT[0].productName}`,
        });
    };

    const handleFrontChange = (value) => {
      if (!value) return;
      setSelectedFront(value);
    };

    useEffect(() => {
      getFrontList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedFront?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refFront}
          value={selectedFront}
          onChange={handleFrontChange}
          options={front}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectHandle = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refHandle = useRef();
    const [handle, setHandle] = useState([]);
    const [selectedHandle, setSelectedHandle] = useState(null);

    const getHandleList = async () => {
      const data1 = { materialStatus: "true" };
      const list = await OAuthService.addData(findAllProductUrl, data1);
      let productList = list.data.filter(
        (d) =>
          d.vendor.map((vendor) => vendor.id).includes(data.productId) &&
          "Handle" === d._class
      );

      setHandle(
        productList.map((product) => ({
          value: `${product.productId} ${product.productName}`,
          label: `${product.productId} ${product.productName}`,
        }))
      );
      const hh = productList.filter(
        (p) => `${p.productId} ${p.productName}` === data[colDef.field]
      );
      if (hh.length > 0)
        setSelectedHandle({
          label: `${hh[0].productId} ${hh[0].productName}`,
          value: `${hh[0].productId} ${hh[0].productName}`,
        });
    };

    const handleHandleChange = (value) => {
      if (!value) return;
      setSelectedHandle(value);
    };

    useEffect(() => {
      getHandleList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedHandle?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refHandle}
          value={selectedHandle}
          onChange={handleHandleChange}
          options={handle}
          styles={customStyles()}
        />
      </div>
    );
  });

  const _getTooltipValue = (params) => {
    return params.data.comment;
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sno.",
      valueGetter: "node.rowIndex + 1",
      maxWidth: 100,
      editable: false,
    },
    { field: "layoutName", enableRowGroup: true, minWidth: 200 },
    {
      field: "product",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectProduct,
    },
    {
      field: "range1",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectRange,
    },
    { field: "priceGroup", enableRowGroup: true, minWidth: 200 },
    {
      field: "front1",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectFront,
    },
    {
      field: "carcass",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectCarCass,
    },
    {
      field: "range2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectRange,
    },
    { field: "priceGroup2", enableRowGroup: true, minWidth: 200 },
    {
      field: "front2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectFront,
    },
    {
      field: "carcass2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectCarCass,
    },
    { field: "scheme", enableRowGroup: true, minWidth: 200 },
    { field: "handleConcept", enableRowGroup: true, minWidth: 200 },
    {
      field: "handle1",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectHandle,
    },
    {
      field: "handle2",
      enableRowGroup: true,
      minWidth: 200,
      cellEditorPopup: true,
      cellEditor: "agRichSelectCellEditor",
      cellEditor: SelectHandle,
    },
    { field: "drawerAccFinish", enableRowGroup: true, minWidth: 200 },
    { field: "drawerType", enableRowGroup: true, minWidth: 200 },
    { field: "antiStpMat", enableRowGroup: true, minWidth: 200 },
    { field: "lightings", enableRowGroup: true, minWidth: 200 },
    { field: "sinkAccsseories", enableRowGroup: true, minWidth: 200 },
    { field: "workTops", enableRowGroup: true, minWidth: 200 },
    { field: "plinths", enableRowGroup: true, minWidth: 200 },
    {
      headerName: "Download",
      cellRenderer: (data) => <Download data={data} />,
      maxWidth: 150,
      minWidth: 150,
      editable: false,
    },
    { field: "remarks", enableRowGroup: true, minWidth: 200 },
    {
      headerName: "Action",
      cellRenderer: Actions,
      maxWidth: 170,
      minWidth: 170,
      editable: false,
      tooltipValueGetter: _getTooltipValue,
    },
  ]);

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(`${url}/${id}`);
      let data = list.data;
      setCurrentStatus(data?.dsLifeCycle);
      setRowData(data?.kitchenQuantities);
      setData(data);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleRequestChange = () => {
    setOpen(true);
  };

  const handleReqCommentSubmit = async (value) => {
    const token =
      localStorage &&
      localStorage.getItem("token") &&
      jwtDecode(localStorage.getItem("token"));
    const payload = {
      ...data,
      kitchenQuantities: gridRef.current.api.getRenderedNodes().map(({ data }) => data),
      dsLifeCycle: "INDIVIDUAL_KITCHEN_DESIGN",
      isDsLifeCyclePassForNextState: false,
      isDsStatusPassForNextState: false,
      comments: {
        additionalProp1: [...data.comments.additionalProp1],
        additionalProp2: [
          ...data.comments.additionalProp2,
          {
            comment: value,
            lastModifiedDate: new Date().toISOString(),
            lastModifyBy: token?.name,
          },
        ],
        additionalProp3: [...data.comments.additionalProp3],
      },
    };
    console.log("payload", payload);
    try {
      await OAuthService.putData(`${url}/${id}`, payload).then((resp) => {
        setOpen(false);
        setCurrentStatus(resp?.dsLifeCycle);
      });
      // setTimeout(() => { navigate("/design-studio/individual-kitchen-design/" + id) }, 400);
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };

  const onRowValueChanged = async (event) => {
    const { colDef, oldValue, newValue } = event;

    if (event.oldValue === event.newValue) {
      let column = event.colDef.field;
      event.column.colDef.cellStyle = { "background-color": "green" };
      event.api.refreshCells({
        force: true,
        column: [column],
        rowNodes: [event.node],
      });
    }
    const obj = {
      createdDate: new Date().toISOString(),
      lastModifiedDate: new Date().toISOString(),
      createdByUser: "Ramde", // need to access from token later
      modifiedByUser: "Ramde",
      srNo: id,
      field: colDef.field,
      oldValues: oldValue,
      newValue: newValue,
      srNo: event.data.srNo,
    };

    setChangeHistory([...changeHistory, obj]);
    setBtnDisable(true);
  };

  return (
    <>
      <FusePageCarded
        classes={{
          content: "flex",
          header: "min-h-72 h-72 sm:h-136 sm:min-h-136",
        }}
        header={
          <ListPageHeader
            componentName="Review Individual Kitchen Design"
            pageName="Review - Individual Kitchen Design"
            showPaginationDropdown={showPaginationDropdown}
            handleApproveAll={handleApproveAll}
            btnDisable={btnDisable}
            handleRequestChange={handleRequestChange}
            status={currentStatus}
            handleBack={handleBack}
            requestCategory={data?.designStudioCategory}
          />
        }
        content={
          <>
            <div className={clsx(classes.root, "px-24 md:px-32")}>
              <Progress currentStep={6} category={data?.designStudioCategory} />
              <Box sx={{ my: 3 }}>
                <Typography variant="subtitle1" className="mb-16">
                  Ground Floor
                </Typography>
                <div style={{ height: "400px" }}>
                  <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    hideCheckbox={true}
                    onCellValueChanged={onRowValueChanged}
                  />
                </div>
              </Box>
              <Typography variant="subtitle1" className="mb-16">
                Download PRW and Presentation
              </Typography>
              <Box>
                <IconButton aria-label="Download PRW" size="large">
                  <PDFSvg />
                </IconButton>
                <IconButton aria-label="Download Presentation" size="large">
                  <PPTSvg />
                </IconButton>
              </Box>
              <Divider sx={{ my: 2, pt: 2 }} />
              <div className="pt-16 mt-10">
                <Button
                  variant="contained"
                  color="warning"
                  size="large"
                  onClick={handleApproveAll}
                  disabled={btnDisable}
                  sx={{ mr: 2 }}
                >
                  APPROVE ALL & Place Order
                </Button>
                <Button
                  variant="outlined"
                  color="warning"
                  size="large"
                  onClick={handleRequestChange}
                >
                  Request a change
                </Button>
              </div>
            </div>
          </>
        }
        innerScroll
      />
      <RequestChange
        open={open}
        handleClose={handleClose}
        id={id}
        data={data}
        handleReqCommentSubmit={handleReqCommentSubmit}
        title={"Request a change"}
      />
    </>
  );
}
